<template>
    <div class="detail">
      <div class="navbar">
        <span @click="$router.go(-1)">< </span>
        <span @click="routerTo('/')">首页</span> /
        <span @click="$router.push('/pcpage_history/history_home')" style="cursor: pointer">往期回顾</span>
        / 短视频 
        <!-- / {{ detail.category_name }}#{{ detail.topic_name }} -->
    </div>
      <div class="content">
        <div class="title">
          {{detail.title}}
        </div>
        <div class="info">
          <div class="left">
            <div class="user">
              {{detail.user_name}}
            </div>
            <div class="country">
              {{detail.cn}}
            </div>
          </div>
          <!-- <div class="right" @click="boost">
            <img src="../img/zan_1.png" alt="">
            <span class="num" v-if="!isShowZAN">{{detail.boost_num}}</span>
            <span class="num" v-if="isShowZAN">+1</span>
          </div> -->
        </div>
        <div class="videoCon" @click="getPlayAuth(detail.video_url)" v-if="!isShowVideo">
          <img :src="'https://collection2021-cos.chineseplus.net/'+detail.video_cover" alt="" class="cover">
          <img src="../../img/m/video_btn.png" alt="" class="playBtn">
          
        </div>
        <div class="player" v-if="isShowVideo">
            <vue-aliplayer-v2
            class="multiple-player"
            ref="VueAliplayerV2"
            v-if="options.vid"
            :options="options"
          />
        </div>
        <div class="desc">
          {{detail.desc}}
        </div>
      </div>
    </div>
</template>

<script>
import VueAliplayerV2 from "vue-aliplayer-v2";
export default {
    name: 'vlogdetail',
    components: {
      VueAliplayerV2
    },
    data: function () {
        return {
            detail: {

            },
            options: {
              vid: "",
              playauth: "",
              height: '500px'
            },
            isShowVideo: false,
            isShowZAN: false
        }
    },
    created() {
      var id = this.$route.query.id
      this.getDetail(id)
    },
    methods: {
      routerTo(path) {
        this.$router.push(path);
      },
      // 登录
      loginFun () {
        const currentUrl = window.location.href
        window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + encodeURIComponent(currentUrl)
      },
      boost() {
        this.$utils.postJson('/vote/api/likeWorks', {
          works_id: this.detail.works_id
        }).then(res => {
          if(res.code == 1000) {
              this.isShowZAN = true
              this.$message({
                message: '您的选票已进入后台审核，稍后请刷新查看最新票数',
                type: "success",
              })
          }else if(res.code == 1002) {
            this.$confirm('当前未登录，前往登录？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.loginFun()
            })
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            })
          }
          
        })
      },
      // 获取播放凭证
      getPlayAuth(vid) {
        this.$utils.get('/works/getPlayAuth', {
          video_id: vid
        }).then(res => {
          this.options.vid = vid
          this.options.playauth = res.data.PlayAuth
          this.isShowVideo = true
        })
      },
      getDetail (id) {
        if(id) {
          this.$utils.get('/works/getInfo', {
            works_id: id
          }).then(res => {
            this.detail = res.data
          })
        }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.detail {
    width: 1200px;
    margin: 50px auto;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .navbar {
      font-size: 24px;
      color: #0b2ab0;
      span {
        cursor: pointer;
      }
    }
    .content {
      width: 1200px;
      padding: 31px 51px;
      box-sizing: border-box;
      background-color: rgba(#fff, 0.8);
      margin-top: 20px;
      .title {
        width: 1000px;
        margin: auto;
        font-size: 36px;
      }
      .info {
        width: 1000px;
        margin: auto;
        margin-top: 15px;
        .left {
          display: inline-block;
          .user,.country {
            font-size: 20px;
            color: #666;
            line-height: 30px;
            margin-top: 5px;
          }
        }
        .right {
          float: right;
          display: inline-block;
          // min-width: 171px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          border: 1px solid #f64109;
          border-radius: 30px;
          background-color: #eb9b08;
          cursor: pointer;
          img {
            vertical-align: middle;
            margin-left: 20px;
            margin-top: 10px;
            float: left;
          }
          .num {
            font-size: 36px;
            color: #ff0707;
            margin: 0 20px;
          }
        }
      }
      .videoCon {
        text-align: center;
        margin-top: 20px;
        position: relative;
        .cover {
          width: 1000px;
          cursor: pointer;
        }
        .playBtn {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 80px;
          cursor: pointer;
        }
      }
      .player {
        width: 1000px;
        margin: 20px auto;
      }
      .desc {
        width: 1000px;
        margin: auto;
        line-height: 1.4;
        margin-top: 20px;
        text-indent: 2em;
      }
    }
}
</style>
